import { z } from "zod";
/**
 * Widget configuration schema
 * All customizable settings for the chat widget
 */
export const widgetConfigSchema = z.object({
    // Assistant info
    assistant_id: z.string().uuid(),
    name: z.string(),
    logo: z.string().optional(),
    first_message: z.string().optional(),
    // Header customization
    header_title: z.string(),
    header_description: z.string().optional(),
    // Theme
    theme: z.enum(["light", "dark", "auto"]),
    // Colors (CSS colors)
    primary_color: z.string(),
    user_bubble_color: z.string(),
    user_bubble_text_color: z.string().optional(),
    ai_bubble_color: z.string(),
    ai_bubble_text_color: z.string().optional(),
    admin_bubble_color: z.string(),
    header_bg_color: z.string(),
    header_text_color: z.string(),
    // Button customization (for embed script)
    button_position: z.enum(["left", "right"]),
    button_color: z.string(),
    button_icon: z.string(), // Lucide icon name or URL
    button_size: z.number(),
    // Voice settings
    voice_enabled: z.boolean().default(false),
    voice_public_key: z.string().optional(),
    default_tab: z.enum(["chat", "voice"]).default("chat"),
    external_assistant_id: z.string().optional(),
    voice_chat_description: z.string().optional(),
});
/**
 * Default widget configuration
 */
export const DEFAULT_WIDGET_CONFIG = {
    logo: undefined,
    first_message: "Hi! How can I help you today?",
    header_title: "Chat with us",
    header_description: "We typically reply within minutes",
    // Theme
    theme: "light",
    // Brand / Primary (neutral black)
    primary_color: "#18181b", // zinc-900
    // Chat bubbles
    user_bubble_color: "#18181b", // zinc-900 (strong, professional)
    user_bubble_text_color: undefined, // Auto-calculated from bubble color
    ai_bubble_color: "#f4f4f5", // zinc-100 (clean contrast)
    ai_bubble_text_color: undefined, // Auto-calculated from bubble color
    admin_bubble_color: "#27272a", // zinc-800 (subtle authority)
    // Header
    header_bg_color: "#09090b", // zinc-950 (classic shadcn black)
    header_text_color: "#fafafa", // zinc-50
    // Floating button
    button_position: "right",
    button_color: "#18181b", // zinc-900
    button_icon: "message-circle",
    button_size: 56,
    // Voice settings (defaults)
    voice_enabled: false,
    voice_public_key: undefined,
    default_tab: "chat",
    external_assistant_id: undefined,
    voice_chat_description: undefined,
};
